<button class="btn btn-primary" (click)="createNewInfo()">
  <fa-icon icon="plus" size="lg"></fa-icon>
  Publier une information
</button>

<app-dynamic-modal-form size="lg"
                        [generator]="informationFormGeneratorService"
                        [actions]="actions"
                        [object]="info"
                        [title]="info?.id ? 'Modification d\'une information' : 'Publication d\'une information'"
                        (onSubmit)="beforeSave($event)"
>
</app-dynamic-modal-form>
